import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import {
  locationMapDavie,
  locationMapFraser,
  mobileMapFraser,
  mobileMapDavie,
} from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => {
        let locationLink = ''
        let mapImageMobile = null
        let mapImage = null
        if (locationId === 'UeW1ehQXkWV2jXhJ14lx') {
          locationLink = 'https://goo.gl/maps/4dCZ8hohsoNTSDt46'
          mapImage = locationMapFraser
          mapImageMobile = mobileMapFraser
        } else {
          locationLink = 'https://goo.gl/maps/1GDDtLJUKeTeZDz26'
          mapImage = locationMapDavie
          mapImageMobile = mobileMapDavie
        }
        return (
          <CFView>
            <MobileScreen>
              <CFLink href={locationLink}>
                <CFImage
                  src={mapImageMobile}
                  w="100%"
                  alt="Samurai Sushi Map"
                />
              </CFLink>
            </MobileScreen>
            <DefaultScreen>
              <CFLink href={locationLink}>
                <CFImage src={mapImage} w="100%" alt="Samurai Sushi Map" />
              </CFLink>
            </DefaultScreen>
          </CFView>
        )
      }}
    </CFSelect>
  )
}
